import PropTypes from 'prop-types';
import { v as bvVar } from 'bv';
import { homeProduct as homeProductConfig } from 'global-config';
import CopySection from './components/copy_section';

/*
Considers main sections to be /sports/{id} /offer/{slug} and any casino lobby
(taken from bvVars, ex /casino, /live-casino, /slots).
These pages have a h1 element at the beginning of the content so should not be
considered here.
*/
const MAIN_SECTION_REGEX = new RegExp(`^/[a-z]{2}-[a-z]{2}(?:${bvVar('casinoLobbies').map(({ slug }) => `/${slug}|`).join('')}/offer/\\w{1,}|/sports/\\w{1,}|/pages/)`);
const [homeProduct] = homeProductConfig.split('::');

const CopySectionsView = ({ copySections, heading, currentPath }) => {
  const isMainSection = (
    (homeProduct === 'casino' && currentPath === '/')
    || MAIN_SECTION_REGEX.test(currentPath)
  );

  if (
    !(copySections && copySections.length)
    && (!heading || isMainSection)
  ) return null;

  return (
    <div className="site-copy-wrapper site-copy">

      {heading && !isMainSection && (
        <h1 className="site-copy-heading bvs-h3">
          {heading}
        </h1>
      )}

      {copySections && copySections.map((section) => (
        <CopySection
          key={section.title}
          title={section.title}
          content={section.content}
        />
      ))}
    </div>
  );
};

CopySectionsView.propTypes = {
  copySections: PropTypes.instanceOf(Array).isRequired,
  heading: PropTypes.string,
  currentPath: PropTypes.string.isRequired,
};

CopySectionsView.defaultProps = {
  heading: null,
};

export default CopySectionsView;
